<app-bundle-details-component [bundleId]="selectedBundleId()" />